import * as React from "react";
import PaginationReact from "react-js-pagination";
import SingleSelect from "../single-select/single-select";
import { PaginationProps } from "./pagination.props";
import "./pagination.scss";

const Pagination = (props: PaginationProps) => {
  const [activePage, setactivePage] = React.useState(props.activePage);
  const [pageSize, setPageSize] = React.useState(props.pageSize);
  const defaultOptions = ["50", "100", "200"];

  React.useEffect(() => {
    setactivePage(props.activePage);
  }, [props.activePage]);

  React.useEffect(() => {
    setPageSize(props.pageSize);
  }, [props.pageSize]);

  const handlePageClick = (pageNumber: any) => {
    setactivePage(pageNumber);
    props.onPageChange(pageNumber, props.pageSize);
  };

  const onPageSizeChange = (newPageSize: string) => {
    const newSize = parseInt(newPageSize);
    if (pageSize != newSize) {
      setactivePage(1);
      setPageSize(newSize);
    }

    props.onPageChange(1, newSize);
    props.onPageSizeChange(newSize);
  };

  const pageCount = Math.ceil(props.itemsCount / props.pageSize);
  const smallestPageSize = props.pageSizeOptions
    ? Math.min(...props.pageSizeOptions.map(Number))
    : Math.min(...defaultOptions.map(Number));

  if (pageCount === 0) return null;
  if (pageCount === 1) {
    return (
      <div className="educator-pagination">
        <div className="educator-pagination-label">
          Viewing Records 1 - {props.itemsCount} of {props.itemsCount}
        </div>
        <div>
          {props.showPageSizeChange && pageSize != smallestPageSize && (
            <SingleSelect
              selected={pageSize.toString()}
              options={props.pageSizeOptions ? props.pageSizeOptions.map(String) : defaultOptions}
              onSelect={onPageSizeChange}
              mpngStyle={props.mpngStyle}
            />
          )}
        </div>
      </div>
    );
  }

  let pageCountArray = [];
  for (let i = 1; i <= pageCount; i++) {
    pageCountArray.push(i);
  }
  let maxPagesVisible = 5;
  if (pageCount < 5) {
    maxPagesVisible = pageCount;
  }

  return (
    <div className={`educator-pagination ${props.mpngStyle ? "mpng-style" : ""}`}>
      <div className="educator-pagination-label">
        Viewing Records {activePage === 1 ? activePage : (activePage - 1) * props.pageSize + 1} -{" "}
        {props.itemsCount >= activePage * props.pageSize ? activePage * props.pageSize : props.itemsCount} of{" "}
        {props.itemsCount}
      </div>
      <div className="educator-pagination-nav" data-testid="educator-pagination-nav">
        <PaginationReact
          activePage={activePage}
          itemsCountPerPage={props.pageSize}
          totalItemsCount={props.itemsCount}
          pageRangeDisplayed={maxPagesVisible}
          onChange={handlePageClick.bind(this)}
          itemClass="educator-page-item"
          linkClass="page-link"
          hideFirstLastPages={true}
        />
      </div>
      <div>
        {props.showPageSizeChange && (
          <SingleSelect
            selected={pageSize.toString()}
            options={props.pageSizeOptions ? props.pageSizeOptions.map(String) : defaultOptions}
            onSelect={onPageSizeChange}
            mpngStyle={props.mpngStyle}
          />
        )}
      </div>
    </div>
  );
};
export default Pagination;
